module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("amXQe"))).then(() => parcelRequire('ikE14'));